<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="selectedUrl ? `transaction/placement-test-content/${inputs.id}` : `transaction/placement-test-content`"
			>
				<div class="form-group row align-items-center">
					<label for="inputs_skill_test" class="col-sm-3 mb-0">
						Skill Test
					</label>
					<app-input
						id="inputs_skill_test"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.skill_test"
						:list="skillTestLists"
						placeholder="Skill Test"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_test_content" class="col-sm-3 mb-0">
						Test Content
					</label>
					<!-- <app-input
						id="inputs_test_content"
						class="col-sm-9"
						type="search-select"
						v-model="inputs.test_content_id"
						:list="testContentLists"
						placeholder="Test Content"
						required
					/> -->
					<app-input
						id="inputs_test_content"
						class="col-sm-9"
						type="text"
						v-model="inputs.test_content"
						placeholder="Test Content"
						required
					/>
				</div>
                <div class="form-group row align-items-center">
					<label for="inputs_material" class="col-sm-3 mb-0">
						Material
					</label>
					<app-input
						id="inputs_material"
						class="col-sm-9"
						type="text"
						v-model="inputs.material"
						placeholder="Material"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_code" class="col-sm-3 mb-0">
						Code
					</label>
					<app-input
						id="inputs_code"
						class="col-sm-9"
						type="text"
						v-model="inputs.code"
						placeholder="Code"
						required
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_score" class="col-sm-3 mb-0">
						Score
					</label>
					<app-input
						id="inputs_score"
						class="col-sm-4"
						type="number"
						v-model="inputs.score"
						placeholder="Score"
						required
					/>
					<div class="col-sm-4">
						<p class="mb-0">1-100</p>
					</div>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_duration" class="col-sm-3 mb-0">
						Duration
					</label>
					<app-input
						id="inputs_duration"
						class="col-sm-4"
						type="number"
						v-model="inputs.duration"
						placeholder="Minutes"
					/>
					<div class="col-sm-4">
						<p class="mb-0">Minutes</p>
					</div>
				</div>
                <div class="form-group row align-items-center">
					<label for="inputs_image" class="col-sm-3 mb-0">
						Image
					</label>
					<app-input
						id="inputs_image"
						class="col-sm-9"
						type="file"
						v-model="inputs.image"
						label="Image"
						required
					/>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "PlacementTestTableForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		placementId: {
			type: Number,
			required: true,
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
				placement_id: this.placementId,
				test_content:null
			},
			skillTestLists: [
				{id: 1, value: 'Reading'},
				{id: 2, value: 'Understanding'},
				{id: 3, value: 'Listening'},
				{id: 4, value: 'Speaking'},
				{id: 5, value: 'Writing'},
			],
			testContentLists: [
				{id: 1, value: 'Reading'},
				{id: 2, value: 'Understanding'},
				{id: 3, value: 'Listening'},
				{id: 4, value: 'Speaking'},
				{id: 5, value: 'Writing'},
			],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}
	},
	// created() {
	// 	if (this.selectedUrl) {
	// 		this.modalTitle = this.$t("edit");
	// 		this.preloader = true;
	// 	}
	// 	this.fetchData();
	// },
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [productResponse] = await Promise.all([
					axios.get("/master/product?is_active=true&per_page=50"),
				]);

				productResponse.data.data.forEach((item) => {
					this.productLists.push({
						id: item.id,
						value: item.name,
					});
				});
			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
			this.inputs.duration = parseInt(this.inputs.duration)
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			if (response.data.phone) this.phone = response.data.phone;
			this.inputs = response.data;
			this.preloader = false;
		},
	},
};
</script>
